import { Package } from 'lucide-react';
import { textoLivre } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/** Lista de 30/10 (item 10): produtos (nome, código e código de barras, a busca da lista). Abre o drawer (`?produto=`). */
interface ProdutoBusca {
  id: string;
  codigo: string;
  nome: string;
  unidade: string;
}

export const buscaEstoque: FonteBuscaGlobal[] = [
  {
    chave: 'produtos',
    permissao: 'estoque.ver',
    pagina: 'estoque.produtos',
    grupo: 'buscaGlobal.produtos',
    posicao: 90,
    icone: Package,
    item: (p: ProdutoBusca) => ({ id: p.id, rotulo: textoLivre(p.nome), detalhe: [p.codigo, p.unidade].filter(Boolean).join(' · '), link: `${caminhoDaAba('estoque', 'produtos')}?produto=${p.id}` }),
  },
];
